import React, { useEffect, useState} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ActionRequired from "./ActionRequired";
import ActionRequested from "./ActionRequested";
import Delivered from "./Delivered";
import { DateRangePicker } from "react-date-range";
import axios from "axios";
import RTO from "./RTO"
import ManualRto from "./ManualRto";
import Cookies from "js-cookie";

// const NdrTab = () => {
// const [activeTab, setActiveTab] = useState("Action Required");

import EmployeeAuthModal from "../employeeAuth/EmployeeAuthModal";
import { ChevronDown } from "lucide-react";

const NdrTab = ({ isSidebarAdmin}) => {
  // const [activeTab, setActiveTab] = useState("Action Required");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [orders, setOrders] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [ndrData, setNdrData] = useState([]);
  const [showCustomCalendar, setShowCustomCalendar] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [dateFilter, setDateFilter] = useState(""); // Add this line
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [orderIds, setOrderIds] = useState("");
  const [awbNumbers, setAwbNumbers] = useState("");
  const [productName, setProductName] = useState("");
  const [channel, setChannel] = useState("");
  const [type, setType] = useState("");
  const [courier, setCourier] = useState("");
  const [attempts, setAttempts] = useState("");
  const location = useLocation()

  const [showEmployeeAuthModal, setShowEmployeeAuthModal] = useState(false);
  const [employeeAccess, setEmployeeAccess] = useState({ isAdmin: false, canView: false });


  const navigate = useNavigate();
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const tabs = ["Action Required", "Action Requested", "Delivered", "RTO Initiated", "Manual RTO"];
  const isNdrRoute = location.pathname === "/adminDashboard/ndr";
  const tabStorageKey = isNdrRoute ? "activeNdrTab" : "activeOrderTab";

  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem(tabStorageKey) || "Action Required";
  });

 
  const params = new URLSearchParams(location.search);
const userId = params.get("userId");
   console.log(userId)

  useEffect(() => {
    localStorage.setItem(tabStorageKey, activeTab);
  }, [activeTab]);


  const toggleFilters = () => {
    if (filtersApplied) {
      clearFilters();
      setFiltersApplied(false);
    } else {
      setShowFilters((prev) => !prev);
    }
  };

  useEffect(() => {
    if (!filtersApplied) {
      setFilteredOrders(orders);
    }
  }, [orders, filtersApplied]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        if (isSidebarAdmin) {
          setEmployeeAccess({ isAdmin: true, canView: true, canAction: true });
          setShowEmployeeAuthModal(false);
          return;
        } else {
          const token = Cookies.get("session");
          const employeeResponse = await axios.get(
            `${REACT_APP_BACKEND_URL}/staffRole/verify`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const employeeInfo = employeeResponse.data.employee;
          // const isAdmin = !!employeeInfo?.isAdmin;
          const canView = !!employeeInfo?.accessRights?.ndr?.['All NDR']?.view;
          setEmployeeAccess({ canView });

          if (!canView) {
            setShowEmployeeAuthModal(true);
            return;
          }

        }
        const token = Cookies.get("session");
        const response = await axios.get(
          `${REACT_APP_BACKEND_URL}/order/orders`,
          {
            headers: {
              authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data);
        setOrders(response.data.orders);
        setRefresh(false);
        setNdrData(response.data?.orders.ndrHistory || []);

        // console.log(orders)
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, [refresh, isSidebarAdmin]);

  const applyFilters = () => {
    let filtered = [...orders]; // Start with all orders

    if (startDate && endDate) {
      filtered = filtered.filter(
        (order) =>
          order.createdAt &&
          new Date(order.createdAt) >= startDate &&
          new Date(order.createdAt) <= endDate
      );
    }

    if (orderIds) {
      const ids = orderIds.split(",").map((id) => id.trim());
      filtered = filtered.filter(
        (order) =>
          order.orderId && ids.includes(order.orderId.toString())
      );
    }

    if (awbNumbers) {
      const awbs = awbNumbers.split(",").map((awb_number) => awb_number.trim());
      filtered = filtered.filter(
        (order) =>
          order.awb_number && awbs.includes(order.awb_number.toString())
      );
    }

    if (productName) {
      filtered = filtered.filter(
        (order) =>
          order.productName &&
          order.productName.toLowerCase().includes(productName.toLowerCase())
      );
    }

    if (channel) {
      filtered = filtered.filter(
        (order) =>
          order.channel && order.channel.toLowerCase() === channel.toLowerCase()
      );
    }

    if (courier) {
      filtered = filtered.filter(
        (order) =>
          order.courierServiceName &&
          order.courierServiceName.toLowerCase() === courier.toLowerCase()
      );
    }

    if (attempts) {
      filtered = filtered.filter(
        (order) =>
          order.ndrHistory && order.ndrHistory.length === parseInt(attempts)
      );
    }

    if (type) {
      filtered = filtered.filter(
        (order) =>
          order.paymentDetails &&
          order.paymentDetails.method &&
          order.paymentDetails.method.toLowerCase() === type.toLowerCase()
      );
    }

    setFilteredOrders(filtered);
    setShowFilters(false);
    setFiltersApplied(true);
  };



  const clearFilters = () => {
    setFiltersApplied(false);
    setStartDate(null);
    setEndDate(null);
    setFromDate("");
    setOrderIds("");
    setAwbNumbers("");
    setProductName("");
    setChannel("");
    setType("");
    setCourier("");
    setAttempts("");
    setFilteredOrders(orders); // Reset to original orders
    setShowCustomCalendar(false);
  };



  const renderTabContent = () => {
    switch (activeTab) {
      case "Action Required":
        return <ActionRequired orders={filteredOrders} userId={userId} />;
      case "Action Requested":
        return <ActionRequested orders={filteredOrders} userId={userId}/>;
      case "Delivered":
        return <Delivered orders={filteredOrders} userId={userId}/>;
      case "RTO Initiated":
        return <RTO orders={filteredOrders} userId={userId}/>
      case "Manual RTO":
        return <ManualRto userId={userId}/>
      default:
        return <div>Select a tab to view orders.</div>;
    }
  };

  const handleDateSuggestion = (value) => {
    let start, end;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    switch (value) {
      case "today":
        start = new Date(today);
        end = new Date(today);
        break;
      case "yesterday":
        start = new Date(today);
        start.setDate(start.getDate() - 1);
        end = new Date(start);
        break;
      case "last7days":
        start = new Date(today);
        start.setDate(today.getDate() - 6);
        end = new Date(today);
        break;
      case "thismonth":
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today);
        break;
      case "lastmonth":
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        end = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case "thisyear":
        start = new Date(today.getFullYear(), 0, 1);
        end = new Date(today);
        break;
      case "custom":
        setShowCustomCalendar(true);
        return;
      default:
        return;
    }
    setSelectionRange({ startDate: start, endDate: end, key: "selection" });
    setStartDate(start);
    setEndDate(end);
    setShowCustomCalendar(false);
  };

  const applyDateFilter = (dateRange) => {
    const { startDate, endDate } = dateRange;
    setFromDate(startDate);
    setEndDate(endDate);

    // Apply filter logic based on startDate and endDate
  };

  const getToday = () => {
    const today = new Date();
    return { startDate: today, endDate: today };
  };

  const getYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return { startDate: yesterday, endDate: yesterday };
  };

  const getLast7Days = () => {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 6); // 7 days ago
    return { startDate: sevenDaysAgo, endDate: today };
  };

  const getThisMonth = () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return { startDate: firstDayOfMonth, endDate: today };
  };

  const getThisYear = () => {
    const today = new Date();
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
    return { startDate: firstDayOfYear, endDate: today };
  };
  const handleDateChange = (ranges) => {
    setSelectionRange(ranges.selection);
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  };

  const handleSelect = (ranges) => {
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  };



  // flex flex-col md:flex-row justify-between items-center gap-4
  return (
    <div
      className={`md:px-2 px-1 ${showModal ? "overflow-hidden" : ""
        }`}
    >
      <div className="mb-1">
        <h1 className="text-[12px] md:text-[18px] font-[600] text-gray-700">NDR</h1>
      </div>

      <div className="flex justify-between items-center md:grid md:grid-cols-2 w-full">
        <div className="hidden md:flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`px-3 py-2 text-[12px] rounded-lg font-[600] transition-all duration-200 ${activeTab === tab
                ? "bg-[#632C9D] text-white"
                : "bg-white text-gray-700 hover:bg-purple-200"
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* <div className="flex justify-end w-full">
          <button
            className={`text-sm md:text-base flex items-center justify-center gap-2 px-6 py-2 rounded-lg border-2 transition-all duration-300 relative ${filtersApplied
              ? "bg-white text-[#2d054b] border-red-500" // Red cross & border when filters are applied
              : showFilters
                ? "bg-[#632C9D] text-white border-[#632C9D]" // Background & text color change when expanded
                : "bg-white text-[#632C9D] border-[#632C9D]" // Default state
              }`}
            onClick={toggleFilters}
          >
            Filters
            {filtersApplied && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="14"
                height="14"
                fill="none"
                stroke="red"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
          </button>
        </div> */}
      </div>
      {!isSidebarAdmin && showEmployeeAuthModal && (
        <EmployeeAuthModal
          employeeModalShow={showEmployeeAuthModal}
          employeeModalClose={() => {
            setShowEmployeeAuthModal(false);
            window.history.back();
          }}
        />
      )}

      {(isSidebarAdmin || employeeAccess.isAdmin || employeeAccess.canView) && (
        <>
         
          

          <div className="relative md:hidden mb-2">
            <button
              className="w-full px-3 py-2 bg-[#632C9D] text-white rounded-lg text-[10px] font-[600] flex justify-between items-center"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              {activeTab} <ChevronDown className="w-3 h-3 ml-2" />
            </button>
            {showDropdown && (
              <div className="absolute top-full left-0 w-full mt-1 bg-white border rounded-lg shadow-lg z-10">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    className={`w-full text-left px-3 py-2 text-[10px] font-[600] text-gray-700 hover:bg-gray-200 ${activeTab === tab ? "bg-purple-100" : "bg-purple-50"}`}
                    onClick={() => {
                      setActiveTab(tab);
                      setShowDropdown(false);
                    }}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="overflow-x-auto">{renderTabContent()}</div>

        </>
      )}


    </div>
  );
};

export default NdrTab;
